// --------------------------------------------------------
// TRIAGEM FIELD - ListaDeProblemasField
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React from "react";
import { H3 } from "../../../../../../../components/UI/generalLayout/Layout.styled";
import { MediumInput } from "../DetailsAttendanceRecord.styled";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// TRIAGEM FIELD INTERFACE
// --------------------------------------------------------

interface IListaDeProblemasField {
  listaDeProblemas: any;
  isViewState: boolean;
  setListaDeProblemas: (value: any) => void;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const ListaDeProblemasField = ({
  listaDeProblemas,
  setListaDeProblemas,
  isViewState,
}: IListaDeProblemasField) => {
  // --------------------------------------------------------
  // TRIAGEM FIELD PRIVATE DECLARATIONS
  // --------------------------------------------------------

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      <div>
        <H3>Detalhes</H3>
        <MediumInput
          disabled={isViewState}
          value={listaDeProblemas}
          onChange={(event: any) => {
            setListaDeProblemas(event.target.value);
          }}
          placeholder="Digite os problemas do paciente"
        />
      </div>
    </>
  );
  // --------------------------------------------------------
};

export default ListaDeProblemasField;
